<auk-message-area [showTemplates]="false" #messageArea (messageChange)="message = $event"></auk-message-area>
